  /*
Reem account

*/
export const environment = {
  production: false,
  environmentName: 'stagingOnline1',
  apiUrl: 'https://api.gcu365.net/api/',
  angularServer: 'https://online.gcu365.net/',
  googleKey: 'AIzaSyAPEty0mkMbLiSrprWzg3_yr3JBJy8HXjI'
};





  /*
   * ng build --prod
   ng build --configuration stagingOnline1
   ng serve --configuration stagingOnline1
   
*/
